<template>
    <transition name="fade">
        <div v-if="isVisible">
            <slot />
        </div>
    </transition>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-collapse component.
 *  @module components/x-collapse
 */

/**
 * x-collapse Component wraps other component hierarchies
 * and shows and hides them based on an interaction function
 */
export default {
    name: 'x-collapse',
    props: {
        dataVisible: String,
    },
    mixins: [
        framework.mixins.abstractElement,
    ],
    computed: {
        isVisible: {
            get() {
                const visibleText = this.getAttribute('visible', '');
                let visible = '';
                if (visibleText.toLowerCase() === 'true') {
                    visible = 'true';
                }

                if (!this.nodeManifest) {
                    return visible;
                }

                if (this.nodeManifest.attributes.dependsOnFunction) {
                    let func = this.convertInteractionFunction(
                        this.nodeManifest.attributes.dependsOnFunction);
                    if (func) {
                        visible = func();
                    }
                }
                return visible;
            },
        },
    },
};
</script>

<style lang="scss">
    @import
        "../../styles/settings",
        "collapse";
</style>





// WEBPACK FOOTER //
// source/components/x-collapse/x-collapse.vue